import { Space } from 'antd';
import { useApplicationDetailsExtraContext } from '../../../components/contexts/ApplicationDetailsExtraContext';
import TradeInMainPanel from './TradeInMainPanel';
import TradeInVehiclePanel from './TradeInVehiclePanel';

const TradeInApplicationTab = ({ updated, offset }: { updated: string; offset: string }) => {
    const { forCI } = useApplicationDetailsExtraContext();

    return (
        <Space direction="vertical" size={forCI ? 48 : 16} style={{ display: 'flex' }}>
            <TradeInMainPanel offset={offset} updated={updated} />
            <TradeInVehiclePanel />
        </Space>
    );
};

export default TradeInApplicationTab;
